import { cancelled, take } from 'redux-saga/effects';
import { createScopedWebSocketEffect, reportWSConnectionError } from '@/domain/ws/clientScoped';
import { Effect, Fiber } from 'effect';

export const WSClientFactory = (dispatch, context, onMessage) =>
  function* initiateWSClient() {
    let fiber = null;

    try {
      const wsEffect = createScopedWebSocketEffect({
        onMessage,
        context,
      }).pipe(Effect.tapError((error) => reportWSConnectionError(error, context)));

      // Run the Effect and get a handle for interruption
      fiber = Effect.runFork(wsEffect);

      // Wait forever until cancelled
      yield take('NEVER');
    } catch (err) {
      console.error('Exception in WS client connection.', err);
    } finally {
      console.log('WSClientFactory finally block entered, cancelled:', yield cancelled());
      if (yield cancelled() && fiber) {
        console.log('Saga cancelled, interrupting Effect');
        try {
          // Use Effect.runPromise as interruption is async and will resolve once Fiber exits
          // If already exited, will resolve immediately
          yield Effect.runPromise(Fiber.interrupt(fiber));
          console.log('Effect interrupted successfully');
        } catch (e) {
          console.error('Error interrupting Effect:', e);
        }
      }
    }
  };

// this is how we should open ws connection in case we want it as bg task for all the pages
// this doesnt handle cancellation properly though

// export default function* ws(dispatch): Saga<*> {
//   yield takeEvery([signInAction.success, getUserDataComplete.type], WSClientFactory(dispatch));
// }
